<div class="container">
  <ion-button
    class="close-icon"
    fill="clear"
    shape="round"
    (click)="data?.closeButtonCallback()"
    (keypress)="true"
    slot="icon-only"
  >
    <ion-icon name="close" color="primary"> </ion-icon>
  </ion-button>
  <img *ngIf="data?.isLogo" [src]="data?.logo" class="logo" alt="Logo"/>
  <div *ngIf="!data?.isLogo" class="imagen">
    <informacion-svg></informacion-svg>
  </div>

  <p class="title">{{ data?.title }}</p>

  <div class="button-container">
    <button class="b-btn s-button" (click)="data?.primaryButtonCallback()">
      {{ data?.primaryButtonText }}
    </button>

    <button class="b-btn p-button" (click)="data?.secondaryButtonCallback()">
      {{ data?.secondaryButtonText }}
    </button>
  </div>
</div>
